<section
  class="customer"
  style="position: relative;"
>

  <div style="position: relative;">
    <div
      *ngIf="(jobShared$ | async)"
      class="shared-job-overlay"
    >
      <p-message
        severity="warn"
        text="This report has unsaved changes"
        styleClass="p-ml-2"
      >
      </p-message>
    </div>

    <app-overview-header></app-overview-header>
  </div>
  <!-- Locations section (partially enabled for shared jobs) -->
  <app-overview-summary></app-overview-summary>

  <div style="position: relative;">
    <div
      *ngIf="(jobShared$ | async)"
      class="shared-job-overlay"
    >
      <p-message
        severity="warn"
        text="This report has unsaved changes"
        styleClass="p-ml-2"
      >
      </p-message>
    </div>

    <app-overview-customer class="p-mt-4"></app-overview-customer>
  </div>
  <p-divider />

  <!-- Locations section (partially enabled for shared jobs) -->
  <app-overview-locations></app-overview-locations>

  <p-divider />

  <div style="position: relative;">
    <div
      *ngIf="(jobShared$ | async)"
      class="shared-job-overlay"
    >
    </div>

    <app-overview-timeline></app-overview-timeline>
  </div>

</section>